import { APIS } from '../../config/apis';
import { ALERT_TYPE, IDS, OPERATION_MODE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { ServerRequest, ServerRequestAsync } from '../../utils/apiweb';
import { CloneObject, cloneEntityInit } from '../../utils/helpers';

// DTO inicial del alta (fuente única: lo usan la vista de detalle y el alta directa de la grilla)
const COMERCIO_ENTITY_INIT = {
    comercio: {
        id: 0,
        idCuenta: 0,
        idEstadoCarga: 20,
        fechaCargaInicio: null,
        fechaCargaFin: null,
        idCuentaInmueble: 0,
        nombreFantasia: "",
        razonSocial: "",
        numeroCuit: "",
        digitoVerificador: "",
        granContribuyente: false,
        idTipoUbicacion: 0
    },
    cuenta: {
        id: 0,
        numeroCuenta: '',
        numeroWeb: '',
        idEstadoCuenta: 1,
        idTipoTributo: 0,
        idTributo: 0,
        fechaAlta: null,
        fechaBaja: null
    },
    relacionesCuentas: [],
    archivos: [],
    observaciones: [],
    etiquetas: [],
    variablesCuenta: [],
    vinculosComercio: [],
    zonasEntrega: [],
    controladoresCuentas: [],
    condicionesEspeciales: [],
    recargosDescuentos: [],
    debitosAutomaticos: [],
    rubrosComercio: [],
    carteles: [],
    inspecciones: [],
    elementos: [],
    declaracionesJuradas: [],
    multas: [],
    espaciosArrendado: [],
    habilitacionesComercio: [],
    retenciones: [],
    domicilioComercio: null,
};

// Factory: cada consumidor recibe su propio clon, así nadie muta el DTO compartido
export const buildComercioEntityInit = () => cloneEntityInit(COMERCIO_ENTITY_INIT);

export const UpdateEntityRow = (typeEntity, row, entity) => {
    // o:original a:add m:modify r:remove c:modify only childs

    if (typeEntity === 'RelacionCuenta') {
        if (row.state === 'a') {
            entity.relacionesCuentas.push(row);
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                entity.relacionesCuentas = entity.relacionesCuentas.filter(f => f.id !== row.id);
            }
            else {
                let item = entity.relacionesCuentas.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
    }

    if (typeEntity === 'VariableCuenta') {
        if (row.state === 'a') {
            entity.variablesCuenta.push(row);
        }
        else if (row.state === 'm') {
            const index = entity.variablesCuenta.indexOf(entity.variablesCuenta.find(x => x.id === row.id));
            if (index !== -1) {
                if (row.id < 0) row.state = 'a'; //originalmente era un alta
                entity.variablesCuenta[index] = row;
            }
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                entity.variablesCuenta = entity.variablesCuenta.filter(f => f.id !== row.id);
            }
            else {
                let item = entity.variablesCuenta.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
    }

    if (typeEntity === 'VinculoComercio') {
        if (row.state === 'a') {
            entity.vinculosComercio.push(row);
        }
        else if (row.state === 'm') {
            const index = entity.vinculosComercio.indexOf(entity.vinculosComercio.find(x => x.id === row.id));
            if (index !== -1) {
                if (row.id < 0) row.state = 'a'; //originalmente era un alta
                entity.vinculosComercio[index] = row;
            }
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                entity.vinculosComercio = entity.vinculosComercio.filter(f => f.id !== row.id);
            }
            else {
                let item = entity.vinculosComercio.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
    }

    if (typeEntity === 'ZonaEntrega') {
        if (row.state === 'a') {
            entity.zonasEntrega.push(row);
        }
        else if (row.state === 'm') {
            const index = entity.zonasEntrega.indexOf(entity.zonasEntrega.find(x => x.id === row.id));
            if (index !== -1) {
                if (row.id < 0) row.state = 'a'; //originalmente era un alta
                entity.zonasEntrega[index] = row;
            }
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                entity.zonasEntrega = entity.zonasEntrega.filter(f => f.id !== row.id);
            }
            else {
                let item = entity.zonasEntrega.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
    }

    if (typeEntity === 'ControladorCuenta') {
        if (row.state === 'a') {
            entity.controladoresCuentas.push(row);
        }
        else if (row.state === 'm') {
            const index = entity.controladoresCuentas.indexOf(entity.controladoresCuentas.find(x => x.id === row.id));
            if (index !== -1) {
                if (row.id < 0) row.state = 'a'; //originalmente era un alta
                entity.controladoresCuentas[index] = row;
            }
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                entity.controladoresCuentas = entity.controladoresCuentas.filter(f => f.id !== row.id);
            }
            else {
                let item = entity.controladoresCuentas.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
    }

    if (typeEntity === 'CondicionEspecial') {
        if (row.state === 'a') {
            entity.condicionesEspeciales.push(row);
        }
        else if (row.state === 'm') {
            const index = entity.condicionesEspeciales.indexOf(entity.condicionesEspeciales.find(x => x.id === row.id));
            if (index !== -1) {
                if (row.id < 0) row.state = 'a'; //originalmente era un alta
                entity.condicionesEspeciales[index] = row;
            }
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                entity.condicionesEspeciales = entity.condicionesEspeciales.filter(f => f.id !== row.id);
            }
            else {
                let item = entity.condicionesEspeciales.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
    }

    if (typeEntity === 'RecargoDescuento') {
        if (row.state === 'a') {
            entity.recargosDescuentos.push(row);
        }
        else if (row.state === 'm') {
            const index = entity.recargosDescuentos.indexOf(entity.recargosDescuentos.find(x => x.id === row.id));
            if (index !== -1) {
                if (row.id < 0) row.state = 'a'; //originalmente era un alta
                entity.recargosDescuentos[index] = row;
            }
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                entity.recargosDescuentos = entity.recargosDescuentos.filter(f => f.id !== row.id);
            }
            else {
                let item = entity.recargosDescuentos.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
    }

    if (typeEntity === 'DebitosAutomaticos') {
        if (row.state === 'a') {
            entity.debitosAutomaticos.push(row);
        }
        else if (row.state === 'm') {
            const index = entity.debitosAutomaticos.indexOf(entity.debitosAutomaticos.find(x => x.id === row.id));
            if (index !== -1) {
                if (row.id < 0) row.state = 'a'; //originalmente era un alta
                entity.debitosAutomaticos[index] = row;
            }
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                entity.debitosAutomaticos = entity.debitosAutomaticos.filter(f => f.id !== row.id);
            }
            else {
                let item = entity.debitosAutomaticos.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
    }

    if (typeEntity === 'Cartel') {
        if (row.state === 'a') {
            entity.carteles.push(row);
        }
        else if (row.state === 'm') {
            const index = entity.carteles.indexOf(entity.carteles.find(x => x.id === row.id));
            if (index !== -1) {
                if (row.id < 0) row.state = 'a'; //originalmente era un alta
                entity.carteles[index] = row;
            }
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                entity.carteles = entity.carteles.filter(f => f.id !== row.id);
            }
            else {
                let item = entity.carteles.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
    }

    if (typeEntity === 'Inspeccion') {
        if (row.state === 'a') {
            entity.inspecciones.push(row);
        }
        else if (row.state === 'm') {
            const index = entity.inspecciones.indexOf(entity.inspecciones.find(x => x.id === row.id));
            if (index !== -1) {
                if (row.id < 0) row.state = 'a'; //originalmente era un alta
                entity.inspecciones[index] = row;
            }
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                entity.inspecciones = entity.inspecciones.filter(f => f.id !== row.id);
            }
            else {
                let item = entity.inspecciones.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
    }

    if (typeEntity === 'Elemento') {
        if (row.state === 'a') {
            entity.elementos.push(row);
        }
        else if (row.state === 'm') {
            const index = entity.elementos.indexOf(entity.elementos.find(x => x.id === row.id));
            if (index !== -1) {
                if (row.id < 0) row.state = 'a'; //originalmente era un alta
                entity.elementos[index] = row;
            }
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                entity.elementos = entity.elementos.filter(f => f.id !== row.id);
            }
            else {
                let item = entity.elementos.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
    }

    if (typeEntity === 'DeclaracionJurada') {
        if (row.state === 'a') {
            entity.declaracionesJuradas.push(row);
        }
        else if (row.state === 'm') {
            const index = entity.declaracionesJuradas.indexOf(entity.declaracionesJuradas.find(x => x.id === row.id));
            if (index !== -1) {
                if (row.id < 0) row.state = 'a'; //originalmente era un alta
                entity.declaracionesJuradas[index] = row;
            }
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                entity.declaracionesJuradas = entity.declaracionesJuradas.filter(f => f.id !== row.id);
            }
            else {
                let item = entity.declaracionesJuradas.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
    }

    if (typeEntity === 'Multa') {
        if (row.state === 'a') {
            entity.multas.push(row)
        }
        else {
            let index = -1
            for (let i = 0; i < entity.multas.length; i++) {
                if (entity.multas[i].id === row.id) {
                    index = i
                    break
                }
            }

            if (row.state === 'm') entity.multas[index] = {...row, state: row.id < 0 ? 'a' : 'm' }
            else {
                if (row.id < 0) entity.multas = [...entity.multas.slice(0, index), ...entity.multas.slice(index + 1)]
                else entity.multas[index] = {...row, state: 'r'}
            }
        }
    }

    if (typeEntity === 'HabilitacionComercio') {
        if (row.state === 'a') {
            entity.habilitacionesComercio.push(row);
        }
        else if (row.state === 'm') {
            const index = entity.habilitacionesComercio.indexOf(entity.habilitacionesComercio.find(x => x.id === row.id));
            if (index !== -1) {
                if (row.id < 0) row.state = 'a'; //originalmente era un alta
                entity.habilitacionesComercio[index] = row;
            }
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                entity.habilitacionesComercio = entity.habilitacionesComercio.filter(f => f.id !== row.id);
            }
            else {
                let item = entity.habilitacionesComercio.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
    }

    if (typeEntity === 'DomicilioComercio') {
        if (row.state === 'm' && row.id < 0) row.state = 'a';
        entity.domicilioComercio = (row.state === 'r' && row.id < 0) ? null : row;
    }

    if (typeEntity === 'EspacioArrendado') {
        if (row.state === 'a') {
            entity.espaciosArrendado.push(row);
        }
        else if (row.state === 'm') {
            const index = entity.espaciosArrendado.indexOf(entity.espaciosArrendado.find(x => x.id === row.id));
            if (index !== -1) {
                if (row.id < 0) row.state = 'a'; //originalmente era un alta
                entity.espaciosArrendado[index] = row;
            }
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                entity.espaciosArrendado = entity.espaciosArrendado.filter(f => f.id !== row.id);
            }
            else {
                let item = entity.espaciosArrendado.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
    }
}

export const FindComercio = (state, setState, callbackNoSuccess, callbackError, callbackSuccessFindComercio) => {
    
    setState(prevState => {
    return {...prevState, loading: true};
    });

    const paramsUrl = `/${state.id}`;

    ServerRequest(
        REQUEST_METHOD.GET,
        null,
        true,
        APIS.URLS.COMERCIO,
        paramsUrl,
        null,
        callbackSuccessFindComercio,
        callbackNoSuccess,
        callbackError
    );

}

export const AddComercio = (state, setState, comercio_formValues, cuenta_formValues, dispatch, navigate, dataTaggerActionClear, callbackNoSuccess, callbackError) => {

    setState(prevState => {
        return {...prevState, loading: true};
    });

    const callbackSuccess = (response) => {
        response.json()
        .then((row) => {
            ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, "Comercio ingresado correctamente", () => {
                dispatch(dataTaggerActionClear(state.processKey));
                setState(prevState => {
                    return {...prevState, loading: false};
                });
                navigate({
                    to: `/comercio/${OPERATION_MODE.EDIT}/${row.comercio.id}`,
                    refresh: true,
                    replace: true,
                });
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        });
    };

    const dataBody = {
        comercio: {
            ...state.entity.comercio,
            idEstadoCarga: comercio_formValues.idEstadoCarga,
            idCuentaInmueble: comercio_formValues.idCuentaInmueble,            
            nombreFantasia: comercio_formValues.nombreFantasia,
            razonSocial: comercio_formValues.razonSocial,
            numeroCuit: comercio_formValues.numeroCuit,
            digitoVerificador: comercio_formValues.digitoVerificador,  
            granContribuyente: comercio_formValues.granContribuyente,
            idTipoUbicacion: comercio_formValues.idTipoUbicacion
        },
        cuenta: {
            ...state.entity.cuenta,
            numeroCuenta: cuenta_formValues.numeroCuenta,
            numeroWeb: cuenta_formValues.numeroWeb
        },
        relacionesCuentas: [],
        archivos: [],
        observaciones: [],
        etiquetas: [],
        variablesCuenta: [],
        vinculosComercio: [],
        zonasEntrega: [],
        controladoresCuentas: [],
        condicionesEspeciales: [],
        recargosDescuentos: [],
        debitosAutomaticos: [],
        rubrosComercio: [],
        carteles: [],
        inspecciones: [],
        elementos: [],
        declaracionesJuradas: [],
        multas: [],
        espaciosArrendado: [],
        habilitacionesComercio: [],
        retenciones: [],
        domicilioComercio: null,
    };

    ServerRequest(
        REQUEST_METHOD.POST,
        null,
        true,
        APIS.URLS.COMERCIO,
        null,
        dataBody,
        callbackSuccess,
        callbackNoSuccess,
        callbackError
    );

}

export const ModifyComercio = (state, setState, dataTagger, comercio_formValues, cuenta_formValues, dispatch, dataTaggerActionClear, callbackNoSuccess, callbackError, callbackSuccessFindComercio) => {

    setState(prevState => {
        return {...prevState, loading: true};
    });

    const callbackSuccess = (response) => {
        ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, "Comercio actualizado correctamente", () => {
            dispatch(dataTaggerActionClear(state.processKey));
            callbackSuccessFindComercio(response);
        });
    };

    const dataBody = {
        comercio: {
            ...state.entity.comercio,
            idEstadoCarga: comercio_formValues.idEstadoCarga,
            idCuentaInmueble: comercio_formValues.idCuentaInmueble,            
            nombreFantasia: comercio_formValues.nombreFantasia,
            razonSocial: comercio_formValues.razonSocial,
            numeroCuit: comercio_formValues.numeroCuit,
            digitoVerificador: comercio_formValues.digitoVerificador,  
            granContribuyente: comercio_formValues.granContribuyente,
            idTipoUbicacion: comercio_formValues.idTipoUbicacion
        },
        cuenta: {
            ...state.entity.cuenta,
            numeroCuenta: cuenta_formValues.numeroCuenta,
            numeroWeb: cuenta_formValues.numeroWeb
        },
        relacionesCuentas: state.entity.relacionesCuentas.filter(f => f.state !== 'o'),
        archivos: (dataTagger[state.processKey]) ? dataTagger[state.processKey].Archivo.filter(f => f.state !== 'o') : [],
        observaciones: (dataTagger[state.processKey]) ? dataTagger[state.processKey].Observacion.filter(f => f.state !== 'o') : [],
        etiquetas: (dataTagger[state.processKey]) ? dataTagger[state.processKey].Etiqueta.filter(f => f.state !== 'o') : [],
        variablesCuenta: state.entity.variablesCuenta, //en este caso hacen falta todos para validar los rangos
        vinculosComercio: state.entity.vinculosComercio, //en este caso hacen falta todos para calcular el referente de la cuenta
        zonasEntrega: state.entity.zonasEntrega.filter(f => f.state !== 'o'),
        controladoresCuentas: state.entity.controladoresCuentas.filter(f => f.state !== 'o'),
        condicionesEspeciales: state.entity.condicionesEspeciales.filter(f => f.state !== 'o'),
        recargosDescuentos: state.entity.recargosDescuentos.filter(f => f.state !== 'o'),
        debitosAutomaticos: state.entity.debitosAutomaticos.filter(f => f.state !== 'o'),
        rubrosComercio: state.entity.rubrosComercio, // en este caso hacen falta todos para verificar los rubros principales
        carteles: state.entity.carteles.filter(f => f.state !== 'o'),
        inspecciones: state.entity.inspecciones.filter(f => f.state !== 'o'),
        elementos: state.entity.elementos.filter(f => f.state !== 'o'),
        declaracionesJuradas: state.entity.declaracionesJuradas.filter(f => f.state !== 'o'),
        multas: state.entity.multas.filter(f => f.state !== 'o'),
        espaciosArrendado: state.entity.espaciosArrendado.filter(f => f.state !== 'o'),
        habilitacionesComercio: state.entity.habilitacionesComercio.filter(f => f.state !== 'o'),
        retenciones: [],
        domicilioComercio: state.entity.domicilioComercio,
    };

    const paramsUrl = `/${state.id}`;

    ServerRequest(
        REQUEST_METHOD.PUT,
        null,
        true,
        APIS.URLS.COMERCIO,
        paramsUrl,
        dataBody,
        callbackSuccess,
        callbackNoSuccess,
        callbackError
    );

}

export const ModifyBajaCuenta = (idCuenta, state, setState, dispatch, navigate, dataTaggerActionClear, callbackNoSuccess, callbackError) => {

    setState(prevState => {
        return {...prevState, loading: true};
    });

    const callbackSuccess = (response) => {
        response.json()
        .then((row) => {
            ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, "La cuenta fue dada de baja correctamente", () => {
                dispatch(dataTaggerActionClear(state.processKey));
                setState(prevState => {
                    return {...prevState, loading: false};
                });
                navigate({
                    to: `/comercio/${OPERATION_MODE.VIEW}/${row.idTributo}`,
                    refresh: true,
                    replace: true,
                })
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        });
    };

    const paramsUrl = `/baja/${idCuenta}`;

    ServerRequest(
        REQUEST_METHOD.PUT,
        null,
        true,
        APIS.URLS.CUENTA,
        paramsUrl,
        null,
        callbackSuccess,
        callbackNoSuccess,
        callbackError
    );

}

export const FindInmueble = async (idCuentaInmueble) => {
    const listDomicilios = [];

    try{
        const responseCuenta = await ServerRequestAsync(REQUEST_METHOD.GET, null, true, APIS.URLS.CUENTA, `/${idCuentaInmueble}`)
        const cuenta = await responseCuenta.json()

        const responseInmueble = await ServerRequestAsync(REQUEST_METHOD.GET, null, true, APIS.URLS.INMUEBLE, `/${cuenta.idTributo}`)
        const inmuebleDto = await responseInmueble.json()
        
        if (inmuebleDto.ladosTerreno.length > 0 && inmuebleDto.cuenta.idDireccionPrincipal) {
            let direccion = null;
            inmuebleDto.ladosTerreno.forEach(x => {
                if (x.direccion.id === inmuebleDto.cuenta.idDireccionPrincipal) {
                    direccion = x.direccion;
                }
            });
            if (direccion) {
                const domicilioInmueble = {...direccion, domicilio: "Inmueble"};
                listDomicilios.push(domicilioInmueble);
            }
        }
    }       
    catch(error) {
        const message = 'No se pudo obtener el domicilio asociado al inmueble: ' + error;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
    }

    return listDomicilios;

}

export const MakeListDomicilios = async (state) => {
    return new Promise(async (resolve, reject) => {
        try {
            let listDomicilios = [];

            if (state.entity.comercio.idCuentaInmueble > 0)
                listDomicilios = await FindInmueble(state.entity.comercio.idCuentaInmueble)

            if (state.entity.zonasEntrega.length > 0 && state.entity.cuenta.idDireccionEntrega) {
                let direccion = null;
                state.entity.zonasEntrega.forEach(x => {
                    if (x.direccion.id === state.entity.cuenta.idDireccionEntrega) {
                        direccion = x.direccion;
                    }
                });
                if (direccion) {
                    const domicilioEntrega = {...direccion, domicilio: "Entrega"};
                    listDomicilios.push(domicilioEntrega);
                }
            }

            const titular = state.entity.vinculosComercio.find(vinculo => vinculo.idTipoVinculoComercio === IDS.TIPO_VINCULO_COMERCIO.TITULAR)
            if (titular) {
                let direccion = null;

                const isPersonaFisica = (titular.idTipoPersona === IDS.TIPO_PERSONA.FISICA);
                const endpoint = isPersonaFisica ? APIS.URLS.PERSONA_FISICA : APIS.URLS.PERSONA_JURIDICA;
                const paramsUrl = `/${titular.idPersona}`;

                try {
                    const res = await ServerRequestAsync(REQUEST_METHOD.GET, null, true, endpoint, paramsUrl);
                    if (res.ok) {
                        try {
                            const data = await res.json();
                            direccion = isPersonaFisica ? data.direccion : data.domicilioLegal;
                        }
                        catch (error) {
                            reject(error);
                            return;
                        }
                    }
                    else {
                        reject(res);
                        return;
                    }
                }
                catch(error) {
                    reject(error);
                    return;
                }

                if (direccion) {
                    const domicilioTitular = {...direccion, domicilio: "Titular"};
                    listDomicilios.push(domicilioTitular);
                }
            }

            resolve(listDomicilios);
        }
        catch (error) {
            reject(error);
        }
    });
}

export function MakeListDomiciliosRelacionados(vinculosTributo) {
    return new Promise(async (resolve, reject) => {
        try {
            let listDomicilios = [];

            const promises = vinculosTributo.map(async (vinculo) => {
                if (vinculo.idTipoVinculoComercio === IDS.TIPO_VINCULO_COMERCIO.TITULAR || 
                    vinculo.idTipoVinculoComercio === IDS.TIPO_VINCULO_COMERCIO.RESPONSABLE_CUENTA) {
                    const isPersonaFisica = (vinculo.idTipoPersona === IDS.TIPO_PERSONA.FISICA);
                    const endpoint = isPersonaFisica ? APIS.URLS.PERSONA_FISICA : APIS.URLS.PERSONA_JURIDICA;
                    const paramsUrl = `/${vinculo.idPersona}`;

                    try {
                        const response = await ServerRequestAsync(REQUEST_METHOD.GET, null, true, endpoint, paramsUrl);
                        if (response.ok) {
                            const data = await response.json();
                            const direccion = isPersonaFisica ? data.direccion : data.domicilioLegal;
                            const tipoVinculo = vinculo.idTipoVinculoComercio === IDS.TIPO_VINCULO_COMERCIO.TITULAR ? 'Titular' : "Responsable de cuenta";
                            const domicilio = { ...direccion, tipoVinculo: tipoVinculo, nombrePersona: vinculo.nombrePersona };
                            return domicilio;
                        }
                    } catch (error) {
                        reject(error);
                    }
                }
            });

            const results = await Promise.all(promises);

            results.forEach(domicilio => {
                if (domicilio) {
                    listDomicilios.push(domicilio);
                }
            });

            resolve(listDomicilios);
        } catch (error) {
            reject(error);
        }
    });
  }